import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, Loader2 } from 'lucide-react';

export default function PaymentMockPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const orderId = searchParams.get('orderId');
  const amount = searchParams.get('amount');

  useEffect(() => {
    // Auto-redirect to success page after 3 seconds
    const timer = setTimeout(() => {
      navigate(`/payment/complete?orderId=${orderId}&status=success`);
    }, 3000);

    return () => clearTimeout(timer);
  }, [orderId, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 text-center">
          <div className="mb-6">
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Mock Payment Mode</h2>
          <p className="text-muted-foreground mb-6">
            This is a simulated payment for testing purposes.
          </p>
          <div className="bg-blue-50 p-4 rounded-md mb-6 text-sm">
            <p><strong>Order ID:</strong> {orderId}</p>
            <p><strong>Amount:</strong> {amount} IQD</p>
            <p className="mt-2 text-blue-700">✓ Payment automatically approved</p>
          </div>
          <div className="flex items-center justify-center gap-2 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" />
            <span>Redirecting to confirmation page...</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
